export default __webpack_public_path__ + "static/media/magnifier-icon.7bdbe4aa.png";